import { COLORS } from "../../styles/uiConstants";

/** Liste filtre sekmeleri — id, kullanıcı `accountStatus` alanıyla eşleşir ("" = tümü) */
export const FILTER_TABS = [
  { id: "", label: "Tümü", countKey: "total" },
  { id: "Aktif", label: "Aktif", countKey: "Aktif" },
  { id: "Askıya Alındı", label: "Askıya Alındı", countKey: "Askıya Alındı" },
  { id: "Donduruldu", label: "Donduruldu", countKey: "Donduruldu" },
  { id: "Devre Dışı", label: "Devre Dışı", countKey: "Devre Dışı" },
];

export const ROLE_OPTIONS = [
  { value: "", label: "Tümü" },
  { value: "Admin", label: "Sistem Yöneticisi" },
  { value: "AdminStaff", label: "Admin Personeli" },
  { value: "ClinicStaff", label: "Klinik Personeli" },
  { value: "Patient", label: "Hasta" },
  { value: "PatientRelative", label: "Hasta Yakını" },
];

export const DIALOG_TITLES = {
  suspend: "Hesabı Askıya Al",
  freeze: "Hesabı Dondur",
  disable: "Hesabı Devre Dışı Bırak",
  activate: "Hesabı Aktifleştir",
};

/**
 * Durum chip stil — nötr/semantik tonlar COLORS token'larından. "Donduruldu"
 * kategorik mavi tona eşlenir (catBlue*) — klinik temasından bağımsız, sabit
 * bir kategori rengi; "aktif değil ama pasif de değil" ara durumu diğer
 * semantik ailelerden (success/warning/error) ayırt eder.
 */
export function getStatusChipSx(status) {
  switch (status) {
    case "Aktif":
      return { bgcolor: COLORS.successLight, color: COLORS.successDarker, fontWeight: 600 };
    case "Askıya Alındı":
      return { bgcolor: COLORS.warningLight, color: COLORS.warningDarker, fontWeight: 600 };
    case "Donduruldu":
      return { bgcolor: COLORS.catBlueLight, color: COLORS.catBlueDark, fontWeight: 600 };
    case "Devre Dışı":
      return { bgcolor: COLORS.errorLight, color: COLORS.errorDark, fontWeight: 600 };
    default:
      return { bgcolor: COLORS.slate100, color: COLORS.slate600, fontWeight: 600 };
  }
}

/**
 * Rol chip stil — roller ayrık kategorilerdir, klinik temasından bağımsız
 * sabit tonlarla ayırt edilir: Admin (kırmızı/error), AdminStaff (pembe/
 * catPink), ClinicStaff (yeşil/success), Patient (mavi/catBlue),
 * PatientRelative (mor/catPurple). Beş rol de görsel olarak birbirinden
 * ayrışır; default nötr slate.
 */
export function getRoleChipSx(role) {
  switch (role) {
    case "Admin":
      return { bgcolor: COLORS.errorLight, color: COLORS.errorDark, fontWeight: 600 };
    case "AdminStaff":
      return { bgcolor: COLORS.catPinkLight, color: COLORS.catPinkDark, fontWeight: 600 };
    case "ClinicStaff":
      return { bgcolor: COLORS.successLight, color: COLORS.successDarker, fontWeight: 600 };
    case "Patient":
      return { bgcolor: COLORS.catBlueLight, color: COLORS.catBlueDark, fontWeight: 600 };
    case "PatientRelative":
      return { bgcolor: COLORS.catPurpleLight, color: COLORS.catPurpleDark, fontWeight: 600 };
    default:
      return { bgcolor: COLORS.slate100, color: COLORS.slate600, fontWeight: 600 };
  }
}

export const DEFAULT_ADMIN_STAFF_FORM = {
  name: "",
  surname: "",
  email: "",
  password: "",
  confirmPassword: "",
  tellNo: "",
  tcNo: "",
  roleTemplateId: "",
  permissions: [],
};
